
import login from '~/mixins/common/pages/login'
import checkSuspendWebsite from '~/mixins/pages/login/checkSuspendWebsite'

export default {
    name: 'Theme3DesktopLogin',
    mixins: [login, checkSuspendWebsite],
    middleware: 'auth',
}
